import React from "react";
import Image1 from "../assets/enabler-images/img_1.png";
import Image2 from "../assets/enabler-images/img_2.png";
import Image3 from "../assets/enabler-images/img_3.png";
import Image4 from "../assets/enabler-images/img_4.png";
import Image5 from "../assets/enabler-images/img_5.png";
import Image6 from "../assets/enabler-images/img_6.png";
import styles from "../styles/enabler.module.css";

function Enabler() {
  return (
    <div className={styles["enable-container"]}>
      <h1 className={styles["title"]}>
        How will this enable new frontier for Web3 gaming projects?
      </h1>
      <div className={styles["introduction-section"]}>
        <div className={`${styles["section"]} animate__animated animate__slideInLeft animate__delay-3s `}>
          <div
            className={`${styles["section-image"]} ${styles["section-alt"]}`}
            id={styles["mobile"]}
          >
            <img src={Image1} alt="img_1" />
          </div>
          <div className={`${styles["section-content"]}`}>
            <p className={styles["section-title"]}>Create in-game challenges</p>
            <p className={styles["section-desc"]}>
              The platform will allow game developers to create and manage in-
              game challenges and tournaments. It will provide a range of
              features and tools to help developers create and customize
              challenges, such as the ability to set specific rules and
              requirements, specify rewards and prizes, and track and analyze
              player participation and performance. The ability to customize
              games provides an appealing user experience; the data feedback can
              mean that developers can adjust their challenges to optimize
              engagement.
            </p>
          </div>
          <div
            className={`${styles["section-image"]} ${styles["section-alt"]}`}
            id={styles["desktop"]}
          >
            <img src={Image1} alt="img_1" />
          </div>
        </div>
        <div className={styles["horizontal-line"]} id={styles["mobile"]}></div>
        <div className={` animate__animated animate__slideInRight animate__delay-3s ${styles["section"]} ${styles["section-alt"]}`}>
          <div className={`${styles["section-image"]} `}>
            <img src={Image2} alt="img_2" />
          </div>
          <div
            className={`${styles["section-content"]} ${styles["section-alt"]}`}
          >
            <p className={styles["section-title"]}>New rewards</p>
            <p className={styles["section-desc"]}>
              The ability to automatically reward successful gamers with
              on-chain rewards establishes a great incentive for any network
              using the platform. Initially, the platform will reward those who
              complete challenges with the HUMAN Token (HMT), but the system
              could be amended to payout any kind of on-chain asset, whether BTC
              or an NFT. Such flexibility creates a new in-game economy that can
              foster new partnerships.
            </p>
          </div>
        </div>
        <div className={styles["horizontal-line"]} id={styles["mobile"]}></div>
        <div className={`${styles["section"]} animate__animated animate__slideInLeft animate__delay-3s`}>
          <div
            className={`${styles["section-image"]} ${styles["section-alt"]}`}
            id={styles["mobile"]}
          >
            <img src={Image3} alt="img_3" />
          </div>
          <div className={`${styles["section-content"]}`}>
            <p className={styles["section-title"]}>Enhance communities</p>
            <p className={styles["section-desc"]}>
              By using a game challenge creation platform, developers can
              increase player engagement and retention by providing a new and
              exciting way for players to interact with their games through
              leaderboards and incentivization.
            </p>
          </div>
          <div
            className={`${styles["section-image"]} ${styles["section-alt"]}`}
            id={styles["desktop"]}
          >
            <img src={Image3} alt="img_3" />
          </div>
        </div>
        <div className={styles["horizontal-line"]} id={styles["mobile"]}></div>
        <div className={` animate__animated animate__slideInRight animate__delay-3s ${styles["section"]}`}>
          <div className={`${styles["section-image"]}`}>
            <img src={Image4} alt="img_4" />
          </div>
          <div
            className={`${styles["section-content"]} ${styles["section-alt"]}`}
          >
            <p className={styles["section-title"]}>Increase replay value</p>
            <p className={styles["section-desc"]}>
              Players who enjoy creating and completing challenges may be more
              likely to play a game multiple times, increasing the replay value
              of the game.
            </p>
          </div>
        </div>
        <div className={styles["horizontal-line"]} id={styles["mobile"]}></div>
        <div className={`${styles["section"]} animate__animated animate__slideInLeft animate__delay-3s`}>
          <div
            className={`${styles["section-image"]} ${styles["section-alt"]}`}
            id={styles["mobile"]}
          >
            <img src={Image5} alt="img_5" />
          </div>
          <div className={`${styles["section-content"]}`}>
            <p className={styles["section-title"]}>Scale and grow</p>
            <p className={styles["section-desc"]}>
              The Signa X platform will soon enable game developers to host
              special events within their games. These challenges can be used to
              promote new game features or content, or to engage and reward
              players for their loyalty.
            </p>
          </div>
          <div
            className={`${styles["section-image"]} ${styles["section-alt"]}`}
            id={styles["desktop"]}
          >
            <img src={Image5} alt="img_5" />
          </div>
        </div>
        <div className={styles["horizontal-line"]} id={styles["mobile"]}></div>
        <div className={`${styles["section"]} animate__animated animate__slideInRight animate__delay-3s`}>
          <div className={`${styles["section-image"]}`}>
            <img src={Image6} alt="img_6" />
          </div>
          <div
            className={`${styles["section-content"]} ${styles["section-alt"]}`}
          >
            <p className={styles["section-title"]}>Boosting monetization</p>
            <p className={styles["section-desc"]}>
              By providing a way for players to create and share challenges,
              game developers will be able to increase their monetization
              through in-app purchases. These rewards will also likely encourage
              more people to try their games.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Enabler;
